import { createSlice } from '@reduxjs/toolkit';

import { API_STATUS } from '../types';

import { ACTION_TYPE_PARENT, setViewTypeAndData} from './actions';

const INITIAL_STATE = {
  status: API_STATUS.idle,
  viewType: "",
  viewData: null
}

/* eslint-disable no-param-reassign */
export const dailyListSlice = createSlice({
  name: ACTION_TYPE_PARENT,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(setViewTypeAndData.pending, (state) => {
        state.status = API_STATUS.loading
      })
      .addCase(setViewTypeAndData.rejected, (state) => {
        state.status = API_STATUS.failed
      })
      .addCase(setViewTypeAndData.fulfilled, (state, action) => {
        state.status = API_STATUS.success;
        state.viewType = action.payload.type;
        state.viewData = action.payload.data;
      })
  }
})
/* eslint-disable no-param-reassign */

export default dailyListSlice.reducer;